module.exports = __webpack_public_path__ + "static/img/drone_02.82e5a22.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/company/drone_02.jpg
// module id = 1/PH
// module chunks = 0